import { useAppSelector } from '../../../hook/useAppSelector';
import { useFooterConfig } from '../../../hook/useFooterConfig';
import { useOrientation } from '../../../hook/useOrientation';
import { useShowRowDensityMenu } from '../../../hook/useShowRowDensityMenu';

import ThumbnailView from '../Content/HealthMonitor/ThumbnailView';

import PageNavigator from './FooterOption/PageNavigator';
import RowDensityMenu from './FooterOption/RowDensityMenu';
import RowsPerPageMenu from './FooterOption/RowsPerPageMenu';
import { useMenus } from '../../../hook/useMenus';
import { t } from 'i18next';

const Footer: React.FC = () => {
  const menus = useMenus();

  const config = useFooterConfig(menus);

  const isThumbnailView = useAppSelector((state) => state.configSlice.isThumbnailView);
  const isMobile = useAppSelector((state) => state.configSlice.isMobile);

  const shouldShowRowDensity = useShowRowDensityMenu();
  const orientation = useOrientation();
  const range = useAppSelector((state) => state.configSlice.table.range);
  return (
    <div className={`row_footer ${orientation}`}>
      {range.total > 0 && config.visibleItemsCount && (
        <div className="visible_items_count">
          {range.from}-{range.to} {t('general.of')} {range.total}
        </div>
      )}
      {!isMobile && (
        <>
          {!isThumbnailView && shouldShowRowDensity && <RowDensityMenu />}
          {config.grid && <ThumbnailView />}
        </>
      )}

      {config.rowsPerPage && <RowsPerPageMenu />}
      {config.pagging && <PageNavigator />}
    </div>
  );
};

export default Footer;
